import script from "./LeaderMyCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderMyCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./LeaderMyCompetencies.vue?vue&type=style&index=0&id=032ea00c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032ea00c"]])

export default __exports__